export const Roles = {
  //   SUPERADMIN: 0,
  ADMIN: 1,
  USER: 2,
};

export const roleOptions = Object.entries(Roles).filter(
  ([key]) => key !== "SUPERADMIN",
);

export const getRoleLabel = (role) => {
  switch (Number(role)) {
    case 0:
      return "Super Admin";
    case Roles.ADMIN:
      return "Admin";
    case Roles.USER:
      return "User";
    default:
      return "N/A";
  }
};
